"use strict";

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : new P(function (resolve) {
        resolve(result.value);
      }).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

var __generator = this && this.__generator || function (thisArg, body) {
  var _ = {
    label: 0,
    sent: function sent() {
      if (t[0] & 1) throw t[1];
      return t[1];
    },
    trys: [],
    ops: []
  },
      f,
      y,
      t,
      g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;

  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }

  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");

    while (_) {
      try {
        if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
        if (y = 0, t) op = [op[0] & 2, t.value];

        switch (op[0]) {
          case 0:
          case 1:
            t = op;
            break;

          case 4:
            _.label++;
            return {
              value: op[1],
              done: false
            };

          case 5:
            _.label++;
            y = op[1];
            op = [0];
            continue;

          case 7:
            op = _.ops.pop();

            _.trys.pop();

            continue;

          default:
            if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _ = 0;
              continue;
            }

            if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
              _.label = op[1];
              break;
            }

            if (op[0] === 6 && _.label < t[1]) {
              _.label = t[1];
              t = op;
              break;
            }

            if (t && _.label < t[2]) {
              _.label = t[2];

              _.ops.push(op);

              break;
            }

            if (t[2]) _.ops.pop();

            _.trys.pop();

            continue;
        }

        op = body.call(thisArg, _);
      } catch (e) {
        op = [6, e];
        y = 0;
      } finally {
        f = t = 0;
      }
    }

    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var NGL = require("ngl");

var data_1 = require("./");
/**
 * A ChellPDB instance provides an API to interact with a loaded PDB file while hiding the implementation details of how it is loaded.
 *
 * @export
 */


var ChellPDB =
/** @class */
function () {
  function ChellPDB() {
    this.fileName = '';
    this.nglData = new NGL.Structure();
  }

  ChellPDB.createEmptyPDB = function () {
    return new ChellPDB();
  };
  /**
   * Creates an instance of ChellPDB with PDB data.
   *
   * !IMPORTANT! Since fetching the data is an asynchronous action, this must be used to create a new instance!
   */


  ChellPDB.createPDB = function (file) {
    if (file === void 0) {
      file = '';
    }

    return __awaiter(this, void 0, void 0, function () {
      var result, _a;

      return __generator(this, function (_b) {
        switch (_b.label) {
          case 0:
            result = new ChellPDB();
            _a = result;
            return [4
            /*yield*/
            , NGL.autoLoad(file)];

          case 1:
            _a.nglData = _b.sent();
            result.fileName = typeof file === 'string' ? file : file.name;
            return [2
            /*return*/
            , result];
        }
      });
    });
  };

  ChellPDB.createPDBFromNGLData = function (nglData) {
    var result = new ChellPDB();
    result.nglData = nglData;
    return result;
  };

  Object.defineProperty(ChellPDB.prototype, "contactInformation", {
    get: function get() {
      var _this = this;

      if (!this.contactInfo) {
        var result_1 = new data_1.CouplingContainer();
        this.nglData.eachResidue(function (outerResidue) {
          if (outerResidue.isProtein()) {
            var i_1 = outerResidue.resno;

            _this.nglData.eachResidue(function (innerResidue) {
              var j = innerResidue.resno;

              if (innerResidue.isProtein() && i_1 !== j) {
                result_1.addCouplingScore({
                  dist: _this.getMinDistBetweenResidues(i_1, j).dist,
                  i: i_1,
                  j: j
                });
              }
            });
          }
        });
        this.contactInfo = result_1;
      }

      return this.contactInfo;
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(ChellPDB.prototype, "nglStructure", {
    get: function get() {
      return this.nglData;
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(ChellPDB.prototype, "secondaryStructure", {
    get: function get() {
      var result = new Array();
      this.nglData.eachResidue(function (residue) {
        if (residue.isProtein()) {
          var structId = 'C';

          if (residue.isSheet()) {
            structId = 'E';
          } else if (residue.isHelix()) {
            structId = 'H';
          } else if (residue.isTurn()) {
            return;
          }

          result.push({
            resno: residue.resno,
            structId: structId
          });
        }
      });
      return result;
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(ChellPDB.prototype, "secondaryStructureSections", {
    get: function get() {
      var result = new Array();
      this.nglData.eachResidue(function (residue) {
        if (residue.isProtein()) {
          var chainIndex = residue.chainIndex;

          while (!result[chainIndex]) {
            result.push(new Array());
          }

          var structId = 'C';

          if (residue.isSheet()) {
            structId = 'E';
          } else if (residue.isHelix()) {
            structId = 'H';
          }

          if (result[chainIndex].length >= 1 && result[chainIndex][result[chainIndex].length - 1].label === structId) {
            result[chainIndex][result[chainIndex].length - 1].updateEnd(residue.resno);
          } else {
            result[chainIndex].push(new data_1.Chell1DSection(structId, residue.resno));
          }
        }
      });
      return result;
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(ChellPDB.prototype, "name", {
    get: function get() {
      var splitName = this.fileName.split('/');
      var lastPart = splitName[splitName.length - 1];
      return lastPart.slice(0, lastPart.lastIndexOf('.'));
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(ChellPDB.prototype, "sequence", {
    get: function get() {
      return this.nglData ? this.nglData.getSequence().join('') : '';
    },
    enumerable: true,
    configurable: true
  });

  ChellPDB.prototype.eachResidue = function (callback) {
    this.nglData.eachResidue(callback);
  };
  /**
   * Given some existing coupling scores, a new CouplingContainer will be created with data augmented with info derived from this PDB.
   *
   * @param couplingScores A collection of coupling scores to be augmented.
   * @param measuredProximity How to calculate the distance between two residues.
   * @returns A CouplingContainer with contact information from both the original array and this PDB file.
   */


  ChellPDB.prototype.amendPDBWithCouplingScores = function (couplingScores, measuredProximity) {
    var _this = this;

    var result = new data_1.CouplingContainer(couplingScores);
    var alphaId = this.nglData.atomMap.dict[ChellPDB.NGL_C_ALPHA_INDEX];
    var minDist = {};
    this.nglData.eachResidue(function (outerResidue) {
      _this.nglData.eachResidue(function (innerResidue) {
        if (outerResidue.isProtein() && innerResidue.isProtein()) {
          if (measuredProximity === data_1.CONTACT_DISTANCE_PROXIMITY.C_ALPHA) {
            var firstResidueCAlphaIndex = _this.getCAlphaAtomIndexFromResidue(outerResidue.index, alphaId);

            var secondResidueCAlphaIndex = _this.getCAlphaAtomIndexFromResidue(innerResidue.index, alphaId);

            result.addCouplingScore({
              dist: _this.nglData.getAtomProxy(firstResidueCAlphaIndex).distanceTo(_this.nglData.getAtomProxy(secondResidueCAlphaIndex)),
              i: outerResidue.resno,
              j: innerResidue.resno
            });
          } else {
            var key = Math.min(outerResidue.resno, innerResidue.resno) + "," + Math.max(outerResidue.resno, innerResidue.resno);

            if (!minDist[key]) {
              minDist[key] = _this.getMinDistBetweenResidueIndices(outerResidue.index, innerResidue.index).dist;
            }

            result.addCouplingScore({
              dist: minDist[key],
              i: outerResidue.resno,
              j: innerResidue.resno
            });
          }
        }
      });
    });
    this.contactInfo = result;
    return this.contactInfo;
  };
  /**
   * Find the index of the c-alpha atom for a given residue.
   *
   * @param residueIndex Index of the residue to find the c-alpha atom for.
   * @param alphaId Index that determines if an atom is a c-alpha.
   * @returns Index of the c-alpha atom with respect to the array of all of the atoms.
   */


  ChellPDB.prototype.getCAlphaAtomIndexFromResidue = function (residueIndex, alphaId) {
    var residueStore = this.nglData.residueStore;
    var atomOffset = residueStore.atomOffset[residueIndex];
    var atomCount = residueStore.atomCount[residueIndex];
    var result = atomOffset;

    while (residueStore.residueTypeId[result] !== alphaId && result < atomOffset + atomCount) {
      result++;
    }

    return result;
  };
  /**
   * Helper function to find the smallest possible distance between two residues via their atoms.
   *
   * @param resnoI The first residue.
   * @param resnoJ The second residue.
   * @returns Shortest distance between the two residues in ångströms.
   */


  ChellPDB.prototype.getMinDistBetweenResidues = function (resnoI, resnoJ) {
    return this.getMinDistBetweenResidueIndices(this.nglData.residueStore.resno.indexOf(resnoI), this.nglData.residueStore.resno.indexOf(resnoJ));
  };

  ChellPDB.prototype.getResidueNumberingMismatches = function (contacts) {
    var result = new Array();
    this.eachResidue(function (residue) {
      var pdbResCode = residue.resname.toUpperCase();
      var couplingAminoAcid = contacts.getAminoAcidOfContact(residue.resno);

      if (couplingAminoAcid && data_1.AMINO_ACIDS_BY_THREE_LETTER_CODE[pdbResCode] !== data_1.AMINO_ACIDS_BY_SINGLE_LETTER_CODE[couplingAminoAcid.singleLetterCode]) {
        result.push({
          firstAminoAcid: data_1.AMINO_ACIDS_BY_SINGLE_LETTER_CODE[couplingAminoAcid.singleLetterCode],
          resno: residue.resno,
          secondAminoAcid: data_1.AMINO_ACIDS_BY_THREE_LETTER_CODE[pdbResCode]
        });
      }
    });
    return result;
  };
  /**
   * Helper function to find the smallest possible distance between two residues via their atoms.
   *
   * @param indexI Index of the first residue with respect to the array of all residues.
   * @param indexJ Index of the second residue with respect to the array of all residues.
   * @returns Shortest distance between the two residues in ångströms.
   */


  ChellPDB.prototype.getMinDistBetweenResidueIndices = function (indexI, indexJ) {
    var residueStore = this.nglData.residueStore;
    var firstResCount = residueStore.atomCount[indexI];
    var secondResCount = residueStore.atomCount[indexJ];
    var firstAtomIndex = residueStore.atomOffset[indexI];
    var secondAtomIndex = residueStore.atomOffset[indexJ];
    var result = {
      atomIndexI: -1,
      atomIndexJ: -1,
      dist: Number.MAX_SAFE_INTEGER
    };

    for (var firstCounter = 0; firstCounter < firstResCount; ++firstCounter) {
      for (var secondCounter = 0; secondCounter < secondResCount; ++secondCounter) {
        var atomIndexI = firstAtomIndex + firstCounter;
        var atomIndexJ = secondAtomIndex + secondCounter;
        var dist = this.nglData.getAtomProxy(atomIndexI).distanceTo(this.nglData.getAtomProxy(atomIndexJ));

        if (dist < result.dist) {
          result = {
            atomIndexI: atomIndexI,
            atomIndexJ: atomIndexJ,
            dist: dist
          };
        }
      }
    }

    return result;
  };

  ChellPDB.NGL_C_ALPHA_INDEX = 'CA|C';
  return ChellPDB;
}();

exports.ChellPDB = ChellPDB;